import { QueryModelCore } from "@/core/model.core";

export default class AdjustLeave {
  /**
   * 获取所有部门
   */
  async getSysQYDep(params) {
    const result = await new QueryModelCore('/api-admin/sysDept/getQYDep').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 获取剩余明细
  async addVacationLogList(params) {
    const result = await new QueryModelCore('/api-admin/app/exam/addVacationLogList').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 获取明细列表
  async vacationLogList(params) {
    const result = await new QueryModelCore('/api-admin/app/exam/vacationLogList').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 修改成员假期余额
   */
  async updateOneUserQuota(params) {
    const result = await new QueryModelCore('/api-admin/app/exam/updateOneUserQuota').post(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取节假日
   */
  async getSysHoliday(params) {
    const result = await new QueryModelCore('/api-admin/app/exam/getSysHoliday').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 每月考勤分页统计
  async attendanceUserMonthPagingList(params) {
    const result = await new QueryModelCore('/api-admin/attendance/attendanceUserMonthPage').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 每日考勤分页统计
  async attendanceUserDayPagingList(params) {
    const result = await new QueryModelCore('/api-admin/app/exam/attendanceUserDayPage').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 用户月度考勤弹窗总结
  async getAttendanceMonth(params) {
    const result = await new QueryModelCore('/api-admin/app/exam/attendanceUserPage').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 用户每日审批单详情列表
  async getattendanceDaySpInfo(params) {
    const result = await new QueryModelCore('/api-admin/attendance/attendanceUserDaySpInfo').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 用户每月考勤导出
  async exportAttendanceMonth(params) {
    const result = await new QueryModelCore('/api-admin/attendance/exportMonth').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 用户每日考勤导出
  async exportAttendanceDay(params) {
    const result = await new QueryModelCore('/api-admin/attendance/exportDay').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 每日内容：考勤和审批单
  async getattendanceUserDayAllInfo(params) {
    const result = await new QueryModelCore('/api-admin/app/exam/attendanceUserDayAllInfo').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 人脸录制邀请列表
  async getFaceUserPagingList(params) {
    const result = await new QueryModelCore('/api-admin/app/exam/getNewUser').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 邀请用户录入人脸
  async updateInviteUsers(params) {
    const result = await new QueryModelCore('/api-admin/app/exam/inviteUsers').post(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 提交人脸数据
  async submitFaceData(params) {
    const result = await new QueryModelCore('/api-admin/app/exam/submitFaceData').post(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 进行照片合规评分
  async updateFaceDetect(params) {
    const result = await new QueryModelCore('/api-admin/app/exam/faceDetect').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 查询人脸数据状态
  async getUserFaceStatus(params) {
    const result = await new QueryModelCore('/api-admin/app/exam/getUserFaceStatus').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 上传企微人脸并评分
  async uplodeFaceImg(params) {
    const result = await new QueryModelCore('/api-admin/app/exam/uploadFaceImg').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  // 查询新员工数据
  async getFaceNewUserInfo(params) {
    const result = await new QueryModelCore('/api-admin/app/exam/getNewUserInfo').get(params);
    const { dataMap } = result;
    return dataMap;
  }

}